import { render, staticRenderFns } from "./levantamentoCard.vue?vue&type=template&id=eed24a14&scoped=true"
import script from "./levantamentoCard.vue?vue&type=script&lang=js"
export * from "./levantamentoCard.vue?vue&type=script&lang=js"
import style0 from "./levantamentoCard.vue?vue&type=style&index=0&id=eed24a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed24a14",
  null
  
)

export default component.exports